import { render } from "./heroComponent.vue?vue&type=template&id=aa76003e"
import script from "./heroComponent.vue?vue&type=script&lang=js"
export * from "./heroComponent.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__